export function safeStringify(obj: unknown): string {
    const seen = new WeakMap<object, string>();

    function serializer(key: string, value: unknown): unknown {
        // eslint-disable-next-line no-underscore-dangle
        const path = this?.__path__ || '$';
        const currentPath = Array.isArray(this) ? `${path}[${key}]` : key ? `${path}.${key}` : path;

        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return `[duplicate of ${seen.get(value)}]`;
            }
            seen.set(value, currentPath);
            // Attach path info without altering arrays or objects
            if (Object.isExtensible(value)) {
                try {
                    Object.defineProperty(value, '__path__', {
                        value: currentPath,
                        enumerable: false,
                    });
                } catch (err) {
                    // Should not happen due to extensibility check, but just in case
                    console.warn(`Could not attach path to value at ${currentPath}:`, err);
                }
            }
        }

        return value;
    }

    return JSON.stringify(obj, serializer);
}
